import { set } from 'date-fns';
import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import smile from '../../assets/img/icons/smile.svg';

export default function ThankYouModal({ www }) {
    const { t } = useTranslation();
    const [show, setShow] = React.useState(true);

    const handleHidePopUp = (e) => {
        setShow(false);

        const isValidURL = (string) => {
            const res = string.match(/^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i);
            return (res !== null);
        }
        // If the URL doesn't start with "http://" or "https://", add "http://"
        if (!www?.startsWith("http://") && !www?.startsWith("https://")) {
            www = "https://" + www;
        }
        if(isValidURL(www))
        window.location.href = www;
        else
        window.location.reload();
    };

    return (
        <Modal className="facebookPopup" show={show} onHide={() => handleHidePopUp()}>
            <ModalHeader closeButton></ModalHeader>
            <ModalBody>
                <div className="modalBody">
                    <img src={smile} className="popupSmile" alt="" />
                    <h3>{t("review.feed")}</h3>
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" onClick={(event) => handleHidePopUp(event)}>{t("review.cl")}</button>
            </ModalFooter>
        </Modal>
    )
}
